import { useState } from "react";
import "./index.css";
import TodoList from "./components/TodoList";
import LoginForm from "./components/LoginForm";
import InstallPrompt from "./components/InstallPrompt";

export function App() {
  // null = unknown (waiting for first API call), true = authed, false = needs login
  const [authed, setAuthed] = useState<boolean | null>(null);

  if (authed === false) {
    return (
      <div className='max-w-7xl mx-auto p-8 text-center relative z-10'>
        <div className='flex justify-center items-center gap-8 mb-8'>
          <div className='max-w-4xl w-full'>
            <h1 className='text-4xl font-bold text-gray-900 mb-8'>Lazy Fuck</h1>
            <LoginForm onSuccess={() => setAuthed(true)} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='max-w-7xl mx-auto p-8 text-center relative z-10'>
      <div className='flex justify-center items-center gap-8 mb-8'>
        <TodoList onUnauthorized={() => setAuthed(false)} />
      </div>
      <InstallPrompt />
    </div>
  );
}

export default App;
